module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery5-3ec841f77b7055a996c9916376b8043f.jpg";